import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const AppsPage = lazy(() => import('./apps-page'));

export const Apps = () => {
  return (
    <LazyRoute>
      <AppsPage />
    </LazyRoute>
  );
};
